<template>
  <SystemPanel>
    <div class="confirm-form confirm-form-with-syspanel">
      <slot>
        <h5>此藥盒數量</h5>
      </slot>
      
      <div class="interactive-input--wrap" v-if="onlyPc">
        <div class="interactive-input">
          <!-- <div class="input-unit">pc.</div> -->
          <div class="calculate-button add-button" @click="addNum('pieces')" v-if="inputReadOnly === false">&plus;</div>
          <input type="number" :class="{ 'form-control': true, 'long-input': inputReadOnly, 'width-input': true }" style="text-align: center" v-model="pieces" ref="input" :readonly="inputReadOnly" min="0"/>
          <div class="calculate-button miuns-button" @click="minusNum('pieces')" v-if="inputReadOnly === false">&minus;</div>
          <!-- <div class="input-multiply">X 1</div> -->
        </div>
      </div>

      <div class="interactive-input--wrap row" v-if="hasSlot === false && onlyPc === false">
        <div class="col-10">
          <div class="interactive-input">
            <div class="input-unit">盒/瓶</div>
            <div class="calculate-button add-button" @click="addNum('packCount')" v-if="inputReadOnly === false">&plus;</div>
            <input type="number" :class="{ 'form-control': true, 'long-input': inputReadOnly }" style="text-align: center" v-model="packCount" ref="input" :readonly="inputReadOnly" min="0"/>
            <div class="calculate-button miuns-button" @click="minusNum('packCount')" v-if="inputReadOnly === false">&minus;</div>
            <div class="input-multiply">X {{ selectedDrug.pack_content }}</div>
          </div>
          <div class="interactive-input">
            <div class="input-unit">pc.</div>
            <div class="calculate-button add-button" @click="addNum('pieces')" v-if="inputReadOnly === false">&plus;</div>
            <input type="number" :class="{ 'form-control': true, 'long-input': inputReadOnly }" style="text-align: center" v-model="pieces" ref="input" :readonly="inputReadOnly" min="0"/>
            <div class="calculate-button miuns-button" @click="minusNum('pieces')" v-if="inputReadOnly === false">&minus;</div>
            <div class="input-multiply">X 1</div>
          </div>
        </div>
        <div class="col-2 amount-sum">
          <p>總數量</p>
          <div class="total-num">
            {{totalSum}}
          </div>
        </div>
      </div>

      <slot name="interactive" v-if="hasSlot">
      </slot>
      
      <div v-if="compType === 'Action'">
        <p style="margin-bottom: 5px" v-if="showRemainInfo">預計剩餘藥物數量 / 藥盒內數量: {{ remainTotalAmount }} / {{ remainAmountInDrugInDevice }}</p>
        <button v-if="canDirectlyToNext" class="btn btn-lg confirm-button" @click="emitData">關閉抽屜或點選以完成動作</button>
        <p v-else class="hint-text">
          <strong>{{ constructionContext }}</strong>
          <span v-if="goToNext === false">完成動作</span>
          <span v-else>進入下一動作</span>
        </p>
      </div>
      <div v-if="compType === 'Confirm'" class="fake-button-wrap">
        <button class="btn control-button control-button-red confirm-amount-button" @click="confirmAmountAction" :disabled="!confirmAvaliable">確認數量</button>
      </div>
      
    </div>
    <lock-device v-if="modalStatus.lockDevice" v-on:errorReturned="errorReturned"/>
    <lock-drawer v-if="modalStatus.lockDrawer" v-on:errorReturned="errorReturned"/>
    <scan-barcode v-show="false" v-on:setBarcode="confirmReturnEmptyBottle" />
  </SystemPanel>
</template>

<script>
import _ from 'lodash';
import SystemPanel from './SystemPanel';
import LockDevice from './LockDevice';
import LockDrawer from './LockDrawer';
import ScanBarcode from './ScanBarcode';


function hasOnlyDrawer(errorDevices) {
  if (errorDevices.length === 1 && errorDevices[0].type === 'drawer') return true;
  return false;
}

function hasOnlyBox(errorDevices) {
  const drawerList = [];
  errorDevices.forEach((item) => {
    if (item.type === 'drawer') drawerList.push(item);
  });
  if (drawerList.length === 0) return true;
  return false;
}

export default {
  name: 'Action',
  props: {
    onlyPc: {
      type: Boolean,
      default: false,
    },
    compType: {
      type: String,
      default: 'Action',
    },
    defaultNum: {
      type: Number,
      default: 0,
    },
    defaultPackCount: {
      type: Number,
      default: 0,
    },
    limitPackCount: {
      type: Boolean,
      default: true,
    },
    deviceId: Number,
    checkNum: Number,
    autoCaculateAmount: {
      type: Boolean,
      default: false,
    },
    inputReadOnly: {
      type: Boolean,
      default: false,
    },
    valueMoreThanZero: {
      type: Boolean,
      default: true,
    },
    hasSlot: {
      type: Boolean,
      default: false,
    },
    defaultEmptyCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      num: 0,
      nextDeviceOnSameNet: true,
      nextDrugStorageOnSameNet: false,
      hasDetctedDrawerOpened: false,
      hasDetctedDeviceAndDrawerOpened: false,
      emitFiredTimes: 0,
      countDownTime: 10000,
      retryTimes: 0,
      accuTime: 0,
      accuFun: null,
      openTimes: 0,
      confirmAvaliable: false,
      forLockUpDevices: [],
      packCount: 0,
      pieces: 0,
      actionTime: 0,
      returnEmptyCount: 0,
    };
  },
  components: {
    SystemPanel,
    LockDevice,
    LockDrawer,
    ScanBarcode,
  },
  async created() {
    setTimeout(() => {
      this.checkDefaultNum();
      this.optimizeNumber();
      this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', this.deviceId);
    }, 200);
    // await this.$store.dispatch('setCurrentDeviceDirectly', this.deviceId);
  },
  mounted() {
    this.hasDetctedDrawerOpened = false;
    this.hasDetctedDeviceAndDrawerOpened = false;
    this.openDevicesById(this.deviceId);
    this.returnEmptyCount = this.defaultEmptyCount;
  },
  destroyed() {
    this.hasDetctedDrawerOpened = false;
    this.hasDetctedDeviceAndDrawerOpened = false;
    console.log('Action destroyed');
    this.stopCountUpTime();
  },
  computed: {
    totalSum() {
      return (this.packCount * this.currentDrugPackContent) + this.pieces;
    },
    modalStatus() {
      return this.$store.getters.modalStatus;
    },
    errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    nextDevice() {
      //20190422 add
       if(this.$store.state.currentApp.name=='類別取藥')
        this.$store.state.device.nextDevice = null;
      ///////////// 
      const next = this.$store.state.device.nextDevice;
      if (next !== null) {
        if (next.net.id === this.currentDevice.net.id) {
          this.nextDeviceOnSameNet = true;
        } else {
          this.nextDeviceOnSameNet = false;
        }
      } else {
        this.nextDeviceOnSameNet = false;
      }
      return next;
    },
    nextDrugInDevice() {
      //20190422 add
       if(this.$store.state.currentApp.name=='類別取藥')
        this.$store.state.drugInDevice.nextDrugInDevice = null;
      /////////////
      return this.$store.state.drugInDevice.nextDrugInDevice;
    },
    canDirectlyToNext() {
      if (this.nextDevice !== null && this.nextDeviceOnSameNet && this.currentDevice.pos_col === 0) {
        return true;
      }
      return false;
    },
    selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    showRemainInfo() {
      const appName = this.currentApp.name;
      if (appName === '一般取藥' || appName === '醫囑取藥' || appName === '一般退藥' || appName === '醫囑退藥') return true;
      return false;
    },
    remainTotalAmount() {
      const appName = this.currentApp.name;
      if (appName === '一般取藥' || appName === '醫囑取藥') return this.selectedDrugTotalAmount - this.num;
      if (appName === '一般退藥' || appName === '醫囑退藥') return this.selectedDrugTotalAmount + this.num;
      return 0;
    },
    remainAmountInDrugInDevice() {
      const appName = this.currentApp.name;
      if (appName === '一般取藥' || appName === '醫囑取藥') return this.currentDrugInDevice.stock - this.num;
      if (appName === '一般退藥' || appName === '醫囑退藥') return this.currentDrugInDevice.stock + this.num;
      return 0;
    },
    currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    currentApp() {
      return this.$store.state.currentApp;
    },
    instance() {
      return this.$store.state.instance;
    },
    errorContext() {
      switch (this.currentApp.name) {
        case '新增藥物':
          return {
            type: 'error',
            context: '新增數量不可大於最大庫存',
            keepOnTop: true,
          };
        case '一般取藥':
        case '醫囑取藥':
        case '批次取藥':
        case '類別取藥':
        case '套組取藥':
          return {
            type: 'warn',
            context: '取藥數量大於此藥盒庫存量或是處方籤量',
            keepOnTop: true,
          };
        case '盤點藥物':
          return {
            type: 'error',
            context: '盤點數量不可大於最大庫存量',
            keepOnTop: true,
          };
        case '補充藥物':
          return {
            type: 'error',
            context: '補充後數量不可大於最大庫存量',
            keepOnTop: true,
          };
        case '一般退藥':
          return {
            type: 'warn',
            context: '<p>退藥數量大於此藥盒容納數量</p> <p>請先完成目前藥盒動作</p>',
            keepOnTop: true,
          };
        default:
          return '';
      }
    },
    goToNext() {
      switch (this.$store.state.currentApp.name) {
        case '一般取藥':
        case '醫囑取藥':
        case '類別取藥':
        case '套組取藥':
        case '一般退藥':
        case '補充藥物':
          if (Math.ceil(this.num) <= Math.ceil(this.checkNum)) {
            return true;
          }
          return false;
        default:
          if (this.nextDevice === null) return false;
          return true;
      }
    },
    constructionContext() {
      if (this.returnedEmptyBottle() === false) {
        return '請先掃描欲退回藥罐，並放回藥盒';
      }
      if (this.hasDetctedDeviceAndDrawerOpened) {
        if (this.goToNext) {
          if (this.nextDeviceOnSameNet || this.nextDrugStorageOnSameNet) return '關閉藥盒';
          if (hasOnlyDrawer(this.errorDevices)) return '關閉抽屜';
          return '關閉藥盒及抽屜';
        }
        if (hasOnlyDrawer(this.errorDevices)) return '關閉抽屜';
        return '關閉藥盒及抽屜';
      }
      if (this.hasDetctedDrawerOpened) return '關閉抽屜';
      return '';
    },
    currentDrugPackContent() {
      if (this.currentDrugInDevice !== null) {
        return this.currentDrugInDevice.medication.pack_content;
      }
      console.log(this.selectedDrug);
      return this.selectedDrug.pack_content;
    },
  },
  methods: {
    countActionTime() {
      setInterval(() => {
        this.actionTime += 1;
      }, 1000);
    },
    checkNextDrugStorage() {
      if (this.nextDrugInDevice !== null && this.nextDrugInDevice !== undefined) {
        if (this.nextDrugInDevice.device.net.id === this.currentDevice.net.id) {
          this.nextDrugStorageOnSameNet = true;
        } else {
          this.nextDrugStorageOnSameNet = false;
        }
      } else {
        this.nextDrugStorageOnSameNet = false;
      }
    },
    openDevicesById(deviceId) {
      this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', deviceId);
      this.$store.dispatch('openDevice');
    },
    checkDefaultNum() {
      if (Math.ceil(this.defaultNum) > Math.ceil(this.checkNum)) {
        this.num = Math.ceil(this.checkNum);
        this.$store.commit('SET_MESSAGE', this.errorContext);
      } else {
        this.num = Math.ceil(this.defaultNum);
      }
    },
    countUpTime() {
      if (this.accuFun === null && this.modalStatus.lockDrawer === false && this.modalStatus.lockDevice === false) {
        console.log('set count up interval');
        this.accuFun = setInterval(() => {
          this.accuTime += 1;
          // console.log('counting time:', this.accuTime);
        }, 1000);
      } else {
        console.log('count up time interval exists');
      }
    },
    stopCountUpTime() {
      if (this.accuFun) {
        console.log('stopCountUpTime');
        clearInterval(this.accuFun);
        this.accuFun = null;
        this.accuTime = 0;
        this.$store.commit('CLOSE_MESSAGE');
      }
    },
    errorReturned() {
      // this.stopCountUpTime();
    },
    resetCountUpTime() {
      this.stopCountUpTime();
      this.countUpTime();
    },
    showLockDeviceModal() {
      this.$store.commit('CLOSE_MESSAGE');
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: true });
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: false });
    },
    closeLockDeviceModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
    },
    showLockDrawerModal() {
      this.$store.commit('CLOSE_MESSAGE');
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: true });
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
    },
    closeLockDrawerModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: false });
      this.showLockDrawerTimeFun = null;
    },
    tryReopenAndShow() {
      console.log('tryReopenAndShow');
      this.preventOverEmitOpenDevices();
      this.$store.commit('SET_MESSAGE', {
        type: 'warn',
        context: '藥盒開啟失敗, 重新嘗試中...',
        confirm: false,
      });
      this.retryTimes += 1;
    },
    checkTimeOnDrawer() {
      // if (this.accuTime === 10 || this.accuTime === 20) {
      //   this.tryReopenAndShow();
      // }
      if (this.accuTime === 10) {
        this.showLockDrawerModal();
      }
    },
    checkTimeOnDevice() {
      // if (this.accuTime === 10 || this.accuTime === 20) {
      //   this.tryReopenAndShow();
      // }
      if (this.accuTime === 10) {
        this.showLockDeviceModal();
      }
    },
    optimizeNumber() {
      if (this.autoCaculateAmount) {
        if (this.currentDrugPackContent !== 0) {
          this.pieces = this.num % this.currentDrugPackContent;
          this.packCount = Math.floor(this.num / this.currentDrugPackContent);
        } else {
          this.packCount = 0;
          this.pieces = this.num;
        }
      } else {
        this.packCount = this.defaultPackCount;
        this.pieces = this.num - (this.packCount * this.currentDrugPackContent);
        console.log(this.packCount, this.pieces, this.num, this.currentDrugPackContent);
      }
    },
    setConfrimAvaliable() {
      this.confirmAvaliable = true;
    },
    checkPackCount() {
      // 看看是否需要檢查藥盒量
      if (this.limitPackCount) {
        if (this.packCount <= this.defaultPackCount) return true;
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '藥盒量不可大於原藥盒量',
          confirm: true,
          keepOnTop: true,
        });
        this.packCount = this.defaultPackCount;
        this.pieces = this.num - (this.packCount * this.currentDrugPackContent);
        return false;
      }
      return true;
    },
    openDeviceAndResetStatus() {
      this.hasDetctedDrawerOpened = false;
      this.hasDetctedDeviceAndDrawerOpened = false;
      this.$store.dispatch('openDevice');
      this.hasDetctedDrawerOpened = false;
      this.hasDetctedDeviceAndDrawerOpened = false;
    },
    confirmReturnEmptyBottle(val) {
      const input = val;
      // get data from barcode and check the drug is as same as current drug.
      if (this.$store.state.generalSetting.fetch_return_empty_same_time) {
        if (input !== `${this.selectedDrug.package_code}`) {
          this.$store.commit('SET_MESSAGE', { type: 'error', keepOnTop: true, confirm: true, context: '請確認掃描條碼與藥瓶（身）條碼相同' });
        } else {
          this.returnEmptyCount += 1;
          this.returnEmptyCount = Math.min(this.returnEmptyCount, this.pieces); // the return empty bottle amount will not larager than fetch amount
        }
      }
    },
    returnedEmptyBottle() {
      // this is a shortcut flow for returning empty when fetching.
      //20190422 add 新增類別取藥也需要回空瓶
      if (this.$store.state.generalSetting.fetch_return_empty_same_time && this.compType === 'Action' && (this.currentApp.name === '一般取藥' || this.currentApp.name === '醫囑取藥' || this.currentApp.name === '類別取藥') && this.selectedDrug.return_when_empty) {
        if (this.returnEmptyCount === 0) return false;
        return true;
      }
      return true;
    },
    checkEmitable() {
      return this.checkPackCount() && this.returnedEmptyBottle();
    },
    emitData() {
      // the emptyCount value is only used when fetch and return empty at the same time.
      console.log('prepare to emit data');
      const vm = this;
      const val = vm.totalSum;
      if (this.checkEmitable()) {
        if (val < 0) {
          vm.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '數值不可以少於0',
            confirm: true,
            keepOnTop: true,
          });
          setTimeout(() => {
            vm.pieces = 0;
          }, 300);
          this.openDeviceAndResetStatus();
        } else if (val === 0 && vm.valueMoreThanZero) {
          vm.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '數值不可以為0',
            confirm: true,
            keepOnTop: true,
          });
          setTimeout(() => {
            vm.pieces = 1;
          }, 300);
          this.openDeviceAndResetStatus();
        } else if (vm.checkNum !== '') {
          // TODO: context should be changed for different app.
          if (Math.ceil(vm.totalSum) > Math.ceil(vm.checkNum)) {
            vm.$store.commit('SET_MESSAGE', vm.errorContext);
            setTimeout(() => {
              this.optimizeNumber();
            }, 300);
            this.openDeviceAndResetStatus();
          } else {
            console.log('hello');
            this.hasDetctedDrawerOpened = false;
            this.hasDetctedDeviceAndDrawerOpened = false;
            vm.$emit('setActionData', {
              device: vm.deviceId,
              num: vm.totalSum,
              packCount: vm.packCount,
              emptyCount: vm.returnEmptyCount,
            });
          }
        } else {
          this.hasDetctedDrawerOpened = false;
          this.hasDetctedDeviceAndDrawerOpened = false;
          vm.$emit('setActionData', {
            device: vm.deviceId,
            num: vm.totalSum,
            packCount: vm.packCount,
            emptyCount: vm.returnEmptyCount,
          });
        }
      } else {
        this.openDeviceAndResetStatus();
      }
    },
    addNum(val) {
      if (this.inputReadOnly !== true) this[val] += 1;
    },
    minusNum(val) {
      if (this.inputReadOnly !== true && this[val] > 0) this[val] -= 1;
    },
    preventOverEmitOpenDevices() {
      this.openTimes += 1;
      if (this.openTimes >= 3 && this.modalStatus.lockDrawer === false && this.modalStatus.lockDevice === false) {
        this.$store.dispatch('openDevice');
        this.openTimes = 0;
      }
    },
    confirmAmountAction() {
      if (this.confirmAvaliable) {
        if (this.totalSum <= this.currentDrugInDevice.max_stock) {
          // determine the storage error event.
          let eventType = '';
          if (this.totalSum === this.currentDrugInDevice.stock) {
            eventType = 'PREPARE_MED';
          } else {
            eventType = 'STORAGE_ERROR';
          }

          const data = {
            id: this.currentDrugInDevice.id,
            device: this.currentDrugInDevice.device.id,
            stock: this.totalSum, // only update here.
            max_stock: this.currentDrugInDevice.max_stock,
            expired_date: this.currentDrugInDevice.expired_date,
            patch_number: this.currentDrugInDevice.patch_number,
            medication: this.currentDrugInDevice.medication.id,
            number1: this.totalSum - this.currentDrugInDevice.stock, // origianl stock
            pack_count: this.packCount,
            type: eventType,
          };

          this.instance.put(`/api/drug-storage/${data.id}/`, data)
          .then((res) => {
            console.log(res.data);
            this.$emit('confirmAmountFinish', {
              totalSum: this.totalSum,
              packCount: this.packCount,
            });
          });
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: `確認數量不可大於最大庫存: ${this.currentDrugInDevice.max_stock}`,
            confirm: true,
            keepOnTop: true,
          });
        }
      }
    },
    checkErrorDeivcesIsCurrentDevice() {
      this.forLockUpDevices = [];
      for (let i = 0; i < this.errorDevices.length; i += 1) {
        const device = this.errorDevices[i];
        if (device.type === 'drawer') {
          // console.log(device);
          //if (device.drawerId !== this.currentDevice.net.row_id || device.system !== (this.currentDevice.net.system.relative_index - 1)) {
          if (device.drawerId !== this.currentDevice.net.row_id) {
            this.forLockUpDevices.push({ type: 'net', id: Object.values(this.$store.getters.systems)[device.system].net_set[device.drawerId - 1].id });
          }
        }
        if (device.type === 'box') {
          // console.log(device);
          if (device.row !== this.currentDevice.pos_row || device.col !== this.currentDevice.relative_col) {
            this.forLockUpDevices.push({ type: 'device', id: Object.values(this.$store.getters.systems)[device.system].net_set[device.drawerId - 1].device_set[device.boxId].id });
          }
        }
      }
      if (this.forLockUpDevices.length > 0) {
        this.$store.commit('SETUP_LOCKED_DEVICES', this.forLockUpDevices);
        return false;
      }
      return true;
    },
    checkErrorDevicesWhenAction: _.throttle((vm) => {
      // console.log(val, 'this.hasDetctedDrawerOpened:', this.hasDetctedDrawerOpened, 'this.hasDetctedDeviceAndDrawerOpened:', this.hasDetctedDeviceAndDrawerOpened);
      // 先確定現在開啟的是抽屜還是藥盒
      switch (vm.currentDevice.pos_row) {
        // 打開抽屜
        case 0:
          if (vm.hasDetctedDrawerOpened === false) {
            vm.countUpTime();
            vm.checkTimeOnDrawer();
          } else {
            vm.stopCountUpTime();
          }
          if (vm.hasDetctedDrawerOpened && vm.errorDevices.length === 0) {
            vm.emitData();
            return;
          }
          if (vm.errorDevices.length > 0) {
            if (!vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true,
              });
            } else {
              if (vm.errorDevices.length === 1) {
                vm.hasDetctedDrawerOpened = true;
              }
            }
          }
          break;
        // 有可能藥盒打不開 需要拉出來
        case 1:
        case 2:
        case 3:
        case 4:
          if (vm.errorDevices.length === 0) {
            // 如果開過藥盒跟抽屜
            if (vm.hasDetctedDeviceAndDrawerOpened) {
              vm.emitData();
            } else {
              if (this.hasDetctedDrawerOpened) {
                vm.preventOverEmitOpenDevices(); // reopening
              }
              vm.countUpTime();
              vm.checkTimeOnDrawer();
            }
          } else if (vm.errorDevices.length === 1) {
            // 如果不小心關起來抽屜但藥盒還沒關閉
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              if (hasOnlyBox(vm.errorDevices)) {
                vm.preventOverEmitOpenDevices();
                if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                  vm.$store.commit('SET_MESSAGE', {
                    type: 'warn',
                    context: '請先關閉藥盒',
                    confirm: true,
                    showUnlock: true,
                  });
                }
              } else { // only drawer open
                this.hasDetctedDrawerOpened = true;
                if (vm.hasDetctedDeviceAndDrawerOpened) { // when finishing the action
                  // 如果下一藥盒在同層抽屜，不用關抽屜，關上藥盒就進行下一步驟
                  if (vm.goToNext) {
                    if (vm.nextDeviceOnSameNet || vm.nextDrugStorageOnSameNet) {
                      vm.emitData();
                    }
                  }
                } else { // waiting for device open
                  console.log('waiting for devices opening');
                  if (hasOnlyDrawer(vm.errorDevices) && (parseInt(vm.errorDevices[0].position, 10) >= parseInt(vm.currentDevice.pos_row, 10))) {
                    vm.countUpTime();
                    vm.checkTimeOnDevice();
                  } else {
                    vm.stopCountUpTime();
                  }
                  if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false && vm.$store.state.modalStatus.lockDevice === false) {
                    vm.$store.commit('SET_MESSAGE', {
                      type: 'warn',
                      context: '請拉開抽屜以打開藥盒',
                      confirm: true,
                      showUnlock: true,
                    });
                  }
                }
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true,
              });
            }
          } else if (vm.errorDevices.length === 2) {
            vm.stopCountUpTime();
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.hasDetctedDeviceAndDrawerOpened = true;
              if (vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('CLOSE_MESSAGE');
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true,
              });
            }
          } else if (vm.errorDevices.length > 2) {
            vm.stopCountUpTime();
            if (!vm.checkErrorDeivcesIsCurrentDevice()) {
              if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('SET_MESSAGE', {
                  type: 'warn',
                  context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                  confirm: true,
                  showUnlock: true,
                  showLockDevice: true,
                });
              }
            }
          } else {
            console.log(vm.errorDevices);
          }
          break;
        default:
          console.error(vm.currentDevice);
      }
    }, 150),
    checkErrorDevicesWhenConfirmAmount: _.throttle((vm) => {
      // console.log(val, 'this.hasDetctedDrawerOpened:', this.hasDetctedDrawerOpened, 'this.hasDetctedDeviceAndDrawerOpened:', this.hasDetctedDeviceAndDrawerOpened);
      // 先確定現在開啟的是抽屜還是藥盒
      switch (vm.currentDevice.pos_row) {
        // 打開抽屜
        case 0:
          if (vm.hasDetctedDrawerOpened === false) {
            vm.countUpTime();
            vm.checkTimeOnDrawer();
          } else {
            vm.stopCountUpTime();
          }
          if (vm.errorDevices.length > 0) {
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.hasDetctedDrawerOpened = true;
              vm.setConfrimAvaliable();
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true,
              });
            }
          }
          break;
        case 1:
        case 2:
        case 3:
        case 4:
          if (vm.errorDevices.length === 0) {
            // 如果開過藥盒跟抽屜
            if (vm.hasDetctedDeviceAndDrawerOpened) {
              vm.setConfrimAvaliable();
            } else {
              if (this.hasDetctedDrawerOpened) {
                vm.preventOverEmitOpenDevices(); // reopening
              }
              vm.countUpTime();
              vm.checkTimeOnDrawer();
            }
          } else if (vm.errorDevices.length === 1) {
            // 如果不小心關起來抽屜但藥盒還沒關閉
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              if (hasOnlyBox(vm.errorDevices)) {
                vm.preventOverEmitOpenDevices();
                if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                  vm.$store.commit('SET_MESSAGE', {
                    type: 'warn',
                    context: '請先關閉藥盒',
                    confirm: true,
                    showUnlock: true,
                  });
                }
              } else { // only drawer open
                this.hasDetctedDrawerOpened = true;
                if (vm.hasDetctedDeviceAndDrawerOpened) { // when finishing the action
                  vm.setConfrimAvaliable();
                } else { // waiting for device open
                  console.log('waiting for devices opening');
                  console.log(parseInt(vm.errorDevices[0].position, 10));
                  if (hasOnlyDrawer(vm.errorDevices) && (parseInt(vm.errorDevices[0].position, 10) >= parseInt(vm.currentDevice.pos_row, 10))) {
                    vm.countUpTime();
                    vm.checkTimeOnDevice();
                  } else {
                    vm.stopCountUpTime();
                  }
                  if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false && vm.$store.state.modalStatus.lockDevice === false) {
                    vm.$store.commit('SET_MESSAGE', {
                      type: 'warn',
                      context: '請拉開抽屜以打開藥盒',
                      confirm: true,
                      showUnlock: true,
                    });
                  }
                }
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true,
              });
            }
          } else if (vm.errorDevices.length === 2) {
            vm.stopCountUpTime();
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.hasDetctedDeviceAndDrawerOpened = true;
              vm.setConfrimAvaliable();
              if (vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('CLOSE_MESSAGE');
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true,
              });
            }
          } else if (vm.errorDevices.length > 2) {
            vm.stopCountUpTime();
            if (!vm.checkErrorDeivcesIsCurrentDevice()) {
              if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('SET_MESSAGE', {
                  type: 'warn',
                  context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                  confirm: true,
                  showUnlock: true,
                  showLockDevice: true,
                });
              }
            }
          } else {
            console.log(vm.errorDevices);
          }
          break;
        default:
          console.error(vm.currentDevice);
      }
    }, 150),
  },
  watch: {
    num(val) {
      // this.debounceCheckNum(this);
      if (isNaN(val)) {
        this.num = 0;
      } else {
        this.num = parseInt(val, 10);
      }
    },
    defaultNum(val) {
      this.checkDefaultNum();
      this.optimizeNumber();
    },
    errorDevices() {
      if (this.compType === 'Action') {
        this.checkNextDrugStorage();
        this.checkErrorDevicesWhenAction(this);
      }
      if (this.compType === 'Confirm') {
        this.checkErrorDevicesWhenConfirmAmount(this);
      }
    },
    pieces(val) {
      if (isNaN(val)) {
        this.pieces = 0;
      } else {
        this.pieces = parseInt(val, 10);
      }
    },
    packCount(val) {
      if (isNaN(val)) {
        console.log('is nan');
        this.packCount = 0;
      } else {
        this.packCount = parseInt(val, 10);
      }
    },
    totalSum(val) {
      this.$emit('setTotalSumInstanly', val);
    },
    compType(val) {
      if (val === 'Action') {
        this.countActionTime();
      }
    },
  },
};
</script>

<style lang="sass">
$button-height: 100px

.interactive-input--wrap
  width: 100%
  display: flex
  flex-direction: row

.interactive-input
  width: 100%
  margin-bottom: 10px
  display: flex
  margin: 10px
  input
    width: calc(100% - #{$button-height * 2})
    font-size: 30px
    border-radius: 0
    height: 50px
  .calculate-button
    width: $button-height
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3)
    color: white
    &:active
      background-color: rgba(0, 0, 0, 0.2)
  .input-unit
    font-size: 16px
    width: 100px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
  .input-multiply
    width: 120px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center

  [class="col-*"]
    padding: 0


.amount-sum
  border-radius: 5px
  border: 1px solid #FF3811
  padding: 0
  hr
    margin: 0.5rem 0
    border-color: 
  p
    margin: 0
    padding: 10px 0
  .total-num
    font-size: 36px
    color: #FF3811
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center

.add-button
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;

.miuns-button
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;

.long-input
  width: 100% !important

.width-input
  width: 100% !important
  height: 65px !important
  

.hint-text
  margin: 0

.custom-hr
  margin: 1rem

.confirm-amount-button
  animation-duration: 0.8s;
  animation-name: confirmButtonBackChanged;
  animation-iteration-count: infinite;
  animation-direction: alternate;

@keyframes confirmButtonBackChanged
  0%
    color: white
  30%
    color: white
  100%
    background: white
    color: #FF3811  


</style>



// WEBPACK FOOTER //
// Action.vue?688b57bb